<template lang="html">
  <div id="favorite-doctors" class="row">
    <div v-if="loader" class="loader"></div>
    <div class="col-lg-3"></div>
    <div class="col-lg-9 searching-vet-container">
      <div class="container-favorite-doctors row">
        <div class="col-sm-12" v-if='favoriteDoctors.length'>
          <div class="row">
            <div class="col-md-4" v-for="(doctor,idx) in favoriteDoctors">
              <div class="row doctor-card" :id="doctor.doctorId">
                <div class="col-md-12" >
                  <span class="doctorThumb" v-if="doctor.doctorAvatar">
                    <img class="img-circle img-fluid img-responsive" v-bind:src="doctor.doctorAvatar" :alt="translation.profile.altImage +doctor.doctorName">
                  </span>
                  <span class="doctorThumb" v-else>
                    <img class="img-circle img-fluid img-responsive" src="../../assets/img/icons/vet-icon.svg" alt="Default Image">
                  </span>
                  <div class="add-favorite-doctor" @click='openVetModal(doctor.doctorId, doctor.doctorFirstName, doctor.doctorLastName)'>
                    <img src="../../assets/img/icons/delete-vet.svg" alt="Favorite Doctor">
                  </div>
                  <div class="add-favorite-text">
                    {{translation.petProfile.delete}}
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="doctorName">
                    {{translation.petReview.addByDoctor + ' ' + doctor.doctorFirstName + translation.profile.space  + doctor.doctorLastName}}
                  </div>
                </div>
                <div class="col-md-12 doctor-other-info" >
                  <div class="doctorAdress">
                    <span v-if="doctor.doctorCountry"><span>{{translation.profile.address}}: </span>{{doctor.doctorCountry}},</span> <span v-if="doctor.doctorCity">{{doctor.doctorCity}},</span><span v-if="doctor.doctorNeighborhood"> {{doctor.doctorNeighborhood}}</span>
                  </div>
                  <div>
                    <span v-if="doctor.clinicName"><span>{{translation.registration.clinic}}: </span>{{doctor.clinicName}}</span>
                  </div>
                  <div>
                    <span v-if="doctor.doctorEmail"><span>{{translation.registration.email}}: </span>{{doctor.doctorEmail}}</span>
                  </div>
                  <div>
                    <span v-if="doctor.doctorPhone"><span>{{translation.registration.phoneNumber}}: </span>{{doctor.doctorPhone}}</span>
                  </div>
                  <div class="text-dots">
                    <span v-if="doctor.clinicWebsite"><a :href="doctor.clinicWebsite" target="_blank"><span>{{translation.registration.website}}: </span>{{doctor.clinicWebsite}}</a></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="col-md-12">
          <h3>{{translation.doctor.noVet}}</h3>
        </div>
        <div class="col-md-12 search-vetlink text-right">
          <router-link to="/searching-vet"><span><img src="../../assets/img/icons/search-vet-red.svg"/> </span>{{translation.doctor.searchDoctorHeader}}</router-link>
        </div>
      </div>
      <div v-if='deleteVetModal' class="modal text-left">
        <div class="modal-content modal-small" >
          <div class="modal-header">
            <h3>{{translation.modalText.modalHeader}}</h3>
            <span class="close-modal" @click="deleteVetModalButton">&times;</span>
          </div>
          <div class="modal-body modal-body-small">
            <p>{{translation.doctor.deleteVet + doctorName + translation.doctor.fromFav}}</p>
          </div>
          <div class="modal-footer">
            <button class=" modal-button-remove  close-modal-button" @click="removeFavorite(doctorId)">{{translation.petProfile.delete}}</button>
            <button class=" modal-button-add" @click="deleteVetModalButton">{{translation.button.noDelete}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      translation: null,
      errors: [],
      doctorId: '',
      doctorName: '',
      deleteVetModal: false,
      loader: false,
      favoriteDoctors: []
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    window.pageHeader = this.translation.doctor.favoriteDoctorsHeader;
    this.getAllFavoriteDoctors();
    this.$bus.$on('add-favorite-doctor', () => {
      this.getAllFavoriteDoctors();
    });
  },
  methods:{
    deleteVetModalButton: function(){
      this.deleteVetModal = false;
    },
    openVetModal: function(id,name,last){
      this.doctorId = id;
      this.doctorName = name + ' ' + last;
      this.deleteVetModal = true;
    },
    getAllFavoriteDoctors: function(){
      this.loader = true;
      var self = this;
      axios.get('get-all-favorite-doctor')
      .then(function (response){
        self.loader = false;
        if (response.data.result) {
          self.favoriteDoctors = response.data.result;
        }
      })
      .catch(err => console.error(err))
    },
    removeFavorite: function(id){
      this.loader = true;
      var formData = this.toFormData({doctorId: id});
      var self = this;
      axios.post('delete-favorite-doctor', formData)
      .then(function(response){
        self.loader = false;
        self.deleteVetModal = false;
        self.$bus.$emit('add-favorite-doctor', true);
        self.bus.$emit('addReview', true);
      })
      .catch(err => err)
    },
    favorite: function(id){
      this.loader = true;
      var formData = this.toFormData({doctorId: id});
      var self = this;
      axios.post('add-favorite-doctor', formData)
      .then(function(response){
        self.loader = false;
        self.$bus.$emit('add-favorite-doctor', true)
        self.bus.$emit('addReview', true);
      })
      .catch(err => err)
    },
    toFormData: function (obj){
      var form_data = new FormData();
      for (var key in obj) {
        form_data.append(key,obj[key]);
      }
      return form_data;
    }
  }
}
</script>

<style>
#favorite-doctors {
  background-image: url('../../assets/img/backgrounds/background-after-login.jpg');
  background-repeat:no-repeat;
  max-width:inherit;
  background-position: center;
  background-size: cover;
  min-height: 100vh;
}
.container-favorite-doctors{
  margin-bottom: 9em;
}
.container-favorite-doctors .doctorThumb img {
    max-width: 8em;
    max-height: 8em;
    width: 8em;
    height: 8em;
    margin-top: 1em;
  }
.doctorName {
  margin-top: 5em;
  color: #3057B0;
  font-weight: bold;
}
.search-vetlink{
  padding-right: 2em;
  padding-top: 1em;
}
.search-vetlink a,.search-vetlink a:hover{
  color: #FE7154;
  font-weight: bold;
}
#favorite-doctors .doctor-other-info{
  margin-top: 2em;
  background: #3057B0;
  padding: 1em;
  color: #fff;
  text-align: center;
  border-bottom-left-radius: .75em;
  border-bottom-right-radius: .75em;
  overflow: hidden;
  text-overflow: ellipsis;
}
#favorite-doctors .doctor-other-info div{
    word-wrap: break-word;
}
#favorite-doctors  .text-dots span,
#favorite-doctors  .text-dots a{
  display: block;
}
.add-favorite-doctor{
  position: absolute;
  top: 1em;
  right: 1em;
  background: transparent;
  border: none;
  z-index: 2;
}
.add-favorite-doctor:hover{
  cursor: pointer;
}
.add-favorite-text{
  display: none;
}
#favorite-doctors h3{
  color: #3057B0;
}
.add-favorite-doctor:hover + .add-favorite-text{
  background: rgba(0, 0, 0, 0.5);
  border-radius: 1em;
  padding-left: .5em;
  padding-right: .5em;
  color: #fff;
  display: block;
  position: absolute;
  right: 0;
  top: 3.3em;
  z-index: 2;
}
.doctor-other-info a{
  color: #fff;
}
.doctor-card{
  background: #fff;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-radius: .75em;
  position: relative;
  margin-bottom: 1em;
}
.doctorThumb img{
  max-width: 8em;
  max-height: 8em;
  width: 8em;
  height: 8em;
  border: 3px solid #3057B0;

}
@media (max-width: 768px) {
  .search-vet-button{
    position: relative!important;
  }
}
</style>
